<div class="main-nav-menu">
  <div class="main-nav-menu__panel">
  @for (menuItem of menuItems; track menuItem) { @if (!menuItem.routerLink) {
  <div
    class="main-nav-menu__item main-nav-menu__item--expandable"
    (click)="toggleMenuItem(menuItem.text)"
    [ngClass]="{ 'bg-primary text-white': menuItem.text === selectedMenuItem }"
    [sarboPermissionsNeeded]="menuItem.permissionsNeeded"
  >
    <div class="flex items-center gap-2">
      <img
        [src]="'../../../../assets/icons/' + menuItem.icon + '.svg'"
        [alt]="menuItem.text + ' Icon'"
        [ngClass]="{ 'svgcolor-white': menuItem.text === selectedMenuItem }"
        class="h-6 w-6"
      />
      <span>{{ menuItem.text | translate }}</span>
    </div>
    @if (menuItem.text === selectedMenuItem) {
    <img src="../../../../../assets/icons/expand_less.svg" [alt]="menuItem.text + ' Icon'" class="svgcolor-white" />
    } @else {
    <img src="../../../../../assets/icons/expand_more_2b2c2c.svg" [alt]="menuItem.text + ' Icon'" />
    }
  </div>
  } @else {
  <div
    class="main-nav-menu__item"
    [routerLink]="menuItem.routerLink"
    routerLinkActive="bg-primary text-white"
    [sarboPermissionsNeeded]="menuItem.permissionsNeeded"
    (click)="selectedMenuSubitem.emit({ text: '', routerLink: '', icon: '', permissionsNeeded: [] })"
  >
    <img
      [src]="'../../../../assets/icons/' + menuItem.icon + '.svg'"
      [alt]="menuItem.text + ' Icon'"
      routerLinkActive="svgcolor-white"
      class="h-6 w-6"
    />
    <span>{{ menuItem.text | translate }}</span>
  </div>
  } }
  </div>

  @for (menuItem of menuItems; track menuItem) {
    @if (menuItem.text === selectedMenuItem && menuItem.subitems?.length) {
    <div class="main-nav-menu__panel">
      @for (menuSubitem of menuItem.subitems; track menuSubitem) {
        @if (menuSubitem.subitems?.length) {
        <div
          class="main-nav-menu__item main-nav-menu__item--expandable"
          (click)="toggleNestedMenuItem(menuSubitem.text)"
          [ngClass]="{ 'bg-primary text-white': menuSubitem.text === selectedNestedMenuItem }"
          [sarboPermissionsNeeded]="menuSubitem.permissionsNeeded"
        >
          <div class="flex items-center gap-2">
            <img
              class="h-6 w-6"
              [src]="'../../../../assets/icons/' + menuSubitem.icon + '.svg'"
              [alt]="menuSubitem.text + ' Icon'"
              [ngClass]="{ 'svgcolor-white': menuSubitem.text === selectedNestedMenuItem }"
            />
            <span>{{ menuSubitem.text | translate }}</span>
          </div>
          <img
            src="../../../../../assets/icons/expand_more_2b2c2c.svg"
            [alt]="menuSubitem.text + ' Icon'"
            [ngClass]="{ 'svgcolor-white': menuSubitem.text === selectedNestedMenuItem }"
          />
        </div>
        } @else {
        <div
          class="main-nav-menu__item"
          [routerLink]="menuSubitem.routerLink"
          routerLinkActive="bg-primary text-white"
          [sarboPermissionsNeeded]="menuSubitem.permissionsNeeded"
          (click)="selectedMenuSubitem.emit(menuSubitem)"
        >
          <img
            class="h-6 w-6"
            [src]="'../../../../assets/icons/' + menuSubitem.icon + '.svg'"
            [alt]="menuSubitem.text + ' Icon'"
            routerLinkActive="svgcolor-white"
          />
          <span> {{ menuSubitem.text | translate }}</span>
        </div>
        }
      }
    </div>
    }
  }

  @for (menuItem of menuItems; track menuItem) {
    @if (menuItem.text === selectedMenuItem && menuItem.subitems?.length) {
      @for (menuSubitem of menuItem.subitems; track menuSubitem) {
        @if (menuSubitem.text === selectedNestedMenuItem && menuSubitem.subitems?.length) {
        <div class="main-nav-menu__panel">
          @for (nestedSubitem of menuSubitem.subitems; track nestedSubitem) {
          <div
            class="main-nav-menu__item"
            [routerLink]="nestedSubitem.routerLink"
            routerLinkActive="bg-primary text-white"
            [sarboPermissionsNeeded]="nestedSubitem.permissionsNeeded"
            (click)="selectedMenuSubitem.emit(nestedSubitem)"
          >
            <img
              class="h-6 w-6"
              [src]="'../../../../assets/icons/' + nestedSubitem.icon + '.svg'"
              [alt]="nestedSubitem.text + ' Icon'"
              routerLinkActive="svgcolor-white"
            />
            <span>{{ nestedSubitem.text | translate }}</span>
          </div>
          }
        </div>
        }
      }
    }
  }
</div>
